import { ArrowLeft, Settings } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import ThemePicker from './ThemePicker';
import GradeSettings from './GradeSettings';
import './SettingsPage.css';

export default function SettingsPage() {
  const nav = useNavigate();
  return <div className="p-4 sm:p-6 max-w-2xl mx-auto space-y-6" data-testid="settings-page">
    <button type="button" onClick={() => nav('/profile')} className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-white"><ArrowLeft size={16} /> Back to profile</button>
    <header><h1 className="text-2xl sm:text-3xl font-heading font-black text-white flex items-center gap-3"><Settings size={28} className="text-cyan-400" /> Settings</h1><p className="text-zinc-500 text-sm mt-1">Your learning preferences and app appearance.</p></header>
      <section className="glass-surface rounded-2xl p-5 border border-white/5">
        <h3 className="text-white font-heading font-bold">Learn your way around</h3>
        <p className="text-zinc-500 text-sm mt-1 mb-3">See the guided walkthrough again, including a sample tutor conversation.</p>
        <button type="button" data-testid="replay-tutorial" data-ace-primary="true" className="rounded-xl border border-solid px-4 py-2 text-sm transition-shadow" onClick={() => window.dispatchEvent(new Event('aceit:start-tour'))}>Start guided demo</button>
      </section>
      <ThemePicker />

      <GradeSettings />
  </div>;
}
